import { MessageCircle, Phone } from "lucide-react";
import { WA_LINK, CALL_LINK } from "@/data";

export default function FloatingButtons() {
  return (
    <>
      {/* WhatsApp — Bottom Right */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-4 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1da853] text-white px-4 py-3 rounded-full shadow-2xl transition-all duration-200 hover:scale-105 min-h-[52px]"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle size={22} fill="white" strokeWidth={0} />
        <span className="text-sm font-semibold">WhatsApp</span>
      </a>

      {/* Call — Bottom Left */}
      <a
        href={CALL_LINK}
        className="fixed bottom-5 left-4 z-50 flex items-center gap-2 bg-[#FF4500] hover:bg-[#e63d00] text-white px-4 py-3 rounded-full shadow-2xl transition-all duration-200 hover:scale-105 min-h-[52px]"
        aria-label="Call Now"
        data-testid="floating-call-btn"
      >
        <Phone size={22} />
        <span className="text-sm font-semibold">Call Now</span>
      </a>
    </>
  );
}
